import { ActivityEntityName, PlannedItem } from '@jms/model';
import { itemFamilyBoard } from '@workbuddy/entities/work.job.item/job.item.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';
import { ITEM_BROWSER_DIALOG_PRESENTATION } from '@workbuddy/ui/blocks/line.items';

/**
 * Catalogue lines owned by a planned-work parent — a Service Line, a Service Line Task, either
 * template twin, or a Visit's exceptions to them. One manifest serves all of them: the parent the
 * board is mounted against decides which lines it reads and what a write means, not the entity.
 * Board and editor use the shared embedded-item base below.
 */
export const plannedItemManifest = registerManifest<PlannedItem>({
  entity: ActivityEntityName.PlannedItem,
  slug: 'planned-item',

  operations: {
    create: {
      kind: 'custom',
      load: () => import('@workbuddy/entities/shared/item.browser.dialog').then(module => module.ItemBrowserDialogComponent),
      presentation: {
        mode: 'dialog',
        ...ITEM_BROWSER_DIALOG_PRESENTATION,
      },
    },
  },

  board: itemFamilyBoard,
});
